import { useMemo as i, Fragment as l } from "react";
import { escapeRegExp as a } from "@material-bank/ds-utils";
import { Text as o } from "./Text.js";
import { jsx as g, jsxs as d } from "theme-ui/jsx-runtime";
const P = (x) => {
  const {
    text: t,
    highlightedText: r,
    highlightedTextSx: m,
    ...s
  } = x, e = i(() => new RegExp(a(r ?? ""), "gi"), [r]), n = i(() => t.split(e), [t, e]), c = i(() => t.match(e) ?? [], [t, e]);
  return r ? /* @__PURE__ */ g(o, {
    ...s,
    children: n.map((p, h) => /* @__PURE__ */ d(l, {
      children: [p, h !== n.length - 1 && /* @__PURE__ */ g(o, {
        inherit: !0,
        sx: {
          fontWeight: "bold",
          ...m
        },
        children: c[h]
      })]
    }, h))
  }) : /* @__PURE__ */ g(o, {
    ...s,
    children: t
  });
};
export {
  P as HighlightedText
};
